@import '../../styles/keyframes.css';

.eds-skeleton {
  animation: eds-skeleton-shimmer 1s linear infinite;
  background-color: var(--eds--color--bg-muted-soft);
  background-image: linear-gradient(
    to right,
    var(--eds--color--bg-muted-soft) 25%,
    var(--eds--color--bg-muted-default) 50%,
    var(--eds--color--bg-muted-soft) 75%
  );
  /* One highlight per sweep, never tiled. */
  background-repeat: no-repeat;
  /* Sized relative to the element so the sweep scales with it — see
     eds-skeleton-shimmer in styles/keyframes.css. */
  background-size: 200% 100%;
  display: block;
  width: 100%;
}

/* A placeholder bar stands in for a line of text, so height comes from the
   type scale. `fill` opts out for parent-sized pieces such as thumbnails. */
.eds-skeleton--size-s {
  height: var(--eds--typography--line-height-16);
}

.eds-skeleton--size-m {
  height: var(--eds--typography--line-height-20);
}

.eds-skeleton--size-l {
  height: var(--eds--typography--line-height-24);
}

.eds-skeleton--size-xl {
  height: var(--eds--typography--line-height-32);
}

.eds-skeleton--size-fill {
  height: 100%;
}

/* Matches AvatarChip.css so the placeholder and the real Avatar occupy the
   same box. */
.eds-skeleton--avatar {
  border-radius: var(--eds--radii-full);
  flex-shrink: 0;
  height: var(--eds--size-32);
  width: var(--eds--size-32);
}

.eds-skeleton--radius-none {
  border-radius: var(--eds--radii-none);
}

.eds-skeleton--radius-s {
  border-radius: var(--eds--radii-4);
}

.eds-skeleton--radius-m {
  border-radius: var(--eds--radii-8);
}

.eds-skeleton--radius-l {
  border-radius: var(--eds--radii-16);
}

.eds-skeleton--radius-full {
  border-radius: var(--eds--radii-full);
}

@media (prefers-reduced-motion: reduce) {
  .eds-skeleton {
    animation: none;
  }
}
